import { connect } from 'react-redux'
import RolodexContactForm from './RolodexContactForm.jsx'

import { createContact, updateContact } from 'src/legacy/redux/actions/rolodex.jsx'
import { updateContactList } from 'src/legacy/redux/actions/contactList.jsx';
import { fetchReportSummary } from 'src/legacy/redux/actions/home.jsx';
import { fetchOrganizations, invalidateOrganizations } from 'src/legacy/redux/actions/organizations.jsx';
import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  return {
    contacts: state.legacyRootReducer.rolodex.items,
    creating: state.legacyRootReducer.rolodex.contact.creating,
    updating: state.legacyRootReducer.rolodex.contact.updating,
    errors: state.legacyRootReducer.rolodex.contact.error,
    organizations: state.legacyRootReducer.organizations.items,
    loading: state.legacyRootReducer.organizations.loading,
    totalRecords: _.get(state.legacyRootReducer, `organizations.pagination.totalRecordsCount`),
    currentPage: _.get(state.legacyRootReducer, `organizations.pagination.currentPage`),
    totalPages: _.get(state.legacyRootReducer, `organizations.pagination.totalPages`)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createContact: (contact) => {
       return dispatch(createContact(contact));
    },

    updateContact: (contact) => {
      return dispatch(updateContact(contact));
    },

    fetchReportSummary: () => {
      return dispatch(fetchReportSummary());
    },

    updateContactList: (contactListId, contact) => {
      return dispatch(updateContactList(contactListId, contact));
    },

    fetchOrganizations: (query, page) => {
      return dispatch(fetchOrganizations(query, page))
    },

    invalidateOrganizations: () => {
      return dispatch(invalidateOrganizations());
    }
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, {
    ...stateProps,
    ...dispatchProps,
    getContactForID: (id) => {
      return stateProps.contacts.find(function(contact){
        return contact.id == id;
      });
    },

    getContactForEmail: (email) => {
      return stateProps.contacts.find(function(contact){
        return contact.email.toLowerCase() == email.toLowerCase();
      });
    }
  })
}

const RolodexContactFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(RolodexContactForm)

export default RolodexContactFormContainer;